import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core'

export enum EmptyStateIllustrationEnum {
  Bird = 'bird',
  Bag = 'bag',
  Cat = 'cat',
  Date = 'date',
  Fridge = 'fridge',
  Planet = 'planet',
}

@Component({
  selector: 'gb-empty-state',
  templateUrl: './gb-empty-state.component.html',
  styleUrls: ['./gb-empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class GbEmptyStateComponent implements OnInit {
  @Input({ required: true }) titleTranslateKey!: string
  @Input() subtitle?: string
  @Input() illustration?: EmptyStateIllustrationEnum

  EmptyStateIllustrationEnum = EmptyStateIllustrationEnum

  presentIllustration!: EmptyStateIllustrationEnum

  ngOnInit() {
    this.presentIllustration = this.illustration || this.getRandomIllustration()
  }

  getRandomIllustration() {
    const enumValues = Object.values(EmptyStateIllustrationEnum)
    const randomIndex = Math.floor(Math.random() * enumValues.length)
    const randomIllustration = enumValues[randomIndex]

    return randomIllustration
  }
}
